import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    sport: '',
    dataAttribution: '',
    __events: [],
    events: [],
    _options: {},
    options: {},
    filters: {},
    showFilterModal: false,
  },
  mutations: {
    setSport(state, sport) {
      state.sport = sport
    },
    setBaseEvents(state, events) {
      /* This should ONLY be set when data is initially loaded from API
         because it also sets the base `_events` data.
      */
      state.__events = events
      state.events = events
    },
    setEvents(state, events) {
      state.events = events
    },
    setOptions(state, options) {
      state.options = options
    },
    resetEvents(state) {
      state.events = state.__events
    },
    setFilters(state, filters) {
      state.filters = filters
    },
    toggleShowFilterModal(state) {
      state.showFilterModal = !state.showFilterModal
    }
  },
  getters: {
    sport: state => state.sport,
    dataAttribution: function(state) {
      let sport = state.sport

      let getAttribution = function(name, url) {
          return `Map data &copy; <a href="${url}" target="_blank">${name}</a> +
                  <a href="https://bryceogden.com/" target="_blank">Bryce Ogden</a> contributors,
                  <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery
                  &copy; <a href="https://www.mapbox.com/">Mapbox</a>`
      }

      if (sport === 'diving') {
          return getAttribution('DiveMeets.com', 'http://divemeets.com')
      } else if (sport === 'weightlifting') {
          return getAttribution('USA Weightlifting', 'https://www.teamusa.org/USA-Weightlifting')
      }
    },
    eventsChanged: state => state.events !== state.__events,
    __events: state => state.__events,
    events: state => state.events,
    options: state => state.options,
    filters: state => state.filters,
    showFilterModal: state => state.showFilterModal,
  },
})



// WEBPACK FOOTER //
// ./src/store/store.js